import FinanceApi from '@/services/FinanceApi';
import Api from "@/services/Index";

const getAll = async (config) => {
    return FinanceApi.get('/other/payments/makeup-lesson', config);
}
const store = async (data) => {
    return FinanceApi.post('/other/payments/makeup-lesson', data);
}
const del = async (id) => {
    return FinanceApi.delete('/other/payments/makeup-lesson/'+id);
}


export default {
    getAll,
    store,
    del
}
